import { render, staticRenderFns } from "./list.vue?vue&type=template&id=2fe4caa5&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=2fe4caa5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe4caa5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fe4caa5')) {
      api.createRecord('2fe4caa5', component.options)
    } else {
      api.reload('2fe4caa5', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=2fe4caa5&scoped=true&", function () {
      api.rerender('2fe4caa5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/more/list.vue"
export default component.exports